import React from "react";

export default function IframeAPI(){
    return(
        <div>
        {/* <iframe src="http://plnkr.co/" height="500" width="500"></iframe> */}
        <iframe src="https://betaplugin.diamondsupload.com/docplugin/6vTPH6oAtNkwvy82mvrfNSyjOI3U6wFV" title="Embeded Code" height={"1000"} width='100%' style={{border:"none"}}></iframe>
        </div>
    )
}